import {Api} from "./Api";
import {ReqPriceData, ResPriceData} from "./structs/PriceData";
import {Zp} from "./Zp";

export class PreisRechner {
    static request(data: ReqPriceData, callback: (response: ResPriceData) => void): void {
        Api.priceRequest(data, r => {
            if (callback) callback(r);
        })
    }

    static bookUrl(response: ResPriceData): string {
        if (!response || !response.price) {
            return "";
        }

        const checkin = Zp.toVacandoTs(Zp.fromIso(response.req.check_in)); // Checkin umwandeln: z.B. "2025-10-18" -> 638963424

        // z.B. /accommodation/book/EBUK1wM5sEqi_U7aY0IyVw/?checkin=638963424&duration=7&pax=1
        return "/accommodation/book/" + response.req.id + "/?checkin=" + checkin + "&duration=" + response.nights + "&pax=" + response.req.pax;
    }
}
